<template>
  <div v-cloak v-if="headerLoaded">
    <div class="vx-card mb-6">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-6">
            <vs-button
              class="vs-button float-right bg_l_green mx-2"
              v-if="headerInfo.checkOutStateQuery == 'در دست بررسی'"
              @click.prevent="createOrderInvoice()"
              :disabled="disabled"
              v-has-permission="permission232"
              >{{ $t("CreateOrder") }}</vs-button
            >
            <router-link
              :to="{
                path:
                  '/ShowPackageInfo/' +
                  headerInfo.id +
                  '/' +
                  headerInfo.draftOrderInfoQuery.draftOrderId
              }"
              class="vs-button bg_purple float-right mx-2"
              v-has-permission="permission235"
            >
              {{ $t("ShowPackageInfo") }}
            </router-link>
            <router-link
              :to="{
                path:
                  '/CheckOutInvoice/' +
                  headerInfo.draftOrderInfoQuery.draftOrderId
              }"
              class="vs-button bg_l_blue float-right mx-2"
              v-has-permission="permission231"
            >
              {{ $t("Invoice") }}
            </router-link>
            <vs-button
              class="vs-button float-right bg_l_blue mx-2"
              @click.prevent="isShowReceiptImage()"
              >{{ $t("ViewReceiptPackage") }}</vs-button
            >
            <vs-button
              type="button"
              class="float-left mx-2"
              style="background-color:#444"
              @click.prevent="backToCurrentGrid()"
              >{{ $t("Back") }}</vs-button
            >
          </div>
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl" id="colored-table">
              <thead>
                <tr>
                  <th style="width:13%">{{ $t("WarehouseName") }}</th>
                  <th style="width:20%">{{ $t("Description") }}</th>
                  <th style="width:10%">{{ $t("OperatorName") }}</th>
                  <th style="width:10%">{{ $t("Applicant") }}</th>
                  <th style="width:8%">{{ $t("AutomationCode") }}</th>
                  <th style="width:13%">{{ $t("CreateOn") }}</th>
                  <th style="width:12%">
                    {{ $t("DocumentRegistrationDate") }}
                  </th>
                  <th style="width:14%">{{ $t("DischargePermission") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width:13%">
                    {{ headerInfo.storeInfoQuery.name }}
                  </td>
                  <td style="width:20%">{{ headerInfo.description }}</td>
                  <td style="width:10%">
                    {{ headerInfo.inventoryOperatorQuery.name }}
                  </td>
                  <td style="width:10%">
                    {{ headerInfo.inventoryRequesterQuery.name }}
                  </td>
                  <td style="width:8%">
                    {{ headerInfo.automationCode }}
                  </td>
                  <td style="width:13%;direction:ltr">
                    {{ headerInfo.persianCreateOn }}
                  </td>
                  <td style="width:12%;direction:ltr">
                    {{ headerInfo.persianRegisterClock }}
                  </td>
                  <td style="width:14%;direction:ltr">
                    <router-link
                      :to="{
                        path:
                          '/DischargePermissions/Details/1/' +
                          headerInfo.draftOrderInfoQuery.dischargePermissionId
                      }"
                    >
                      <vs-button
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-eye"
                        class="view-btn"
                        v-has-permission="permission233"
                        >{{
                          headerInfo.draftOrderInfoQuery.dischargePermissionId
                        }}
                      </vs-button>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full m-0">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('ShelveName'), sort: 'ShelveName' },
                { title: $t('StockName'), sort: 'StockName' },
                { title: $t('ItemCode'), sort: 'ItemCode' },
                { title: $t('Count'), sort: 'Count' },
                { title: $t('Serial'), sort: 'Serial' }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width:18%">
                  {{ row.shelveName }}
                </td>
                <td style="width:40%">
                  {{ row.stockName }}
                </td>
                <td style="width:17%">
                  {{ row.itemCode }}
                </td>
                <td style="width:10%">
                  {{ row.count }}
                </td>
                <td style="width:25%">
                  <span v-if="row.stockType == 1">
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="custom-border-btn"
                      @click="
                        viewSerials(
                          row.inventoryTransactionId,
                          row.shelveId,
                          row.stockId
                        )
                      "
                      v-has-permission="'GetSerialsOfStock'"
                      >{{ $t("ViewSerials") }}</vs-button
                    >
                  </span>
                  <span v-else>-</span>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
    <receipt-image-popup
      :show="onShowReceiptImagePopup"
      :PackagereceiptImageInfo="PackagereceiptImageInfo"
      @finish="onfinish"
      id="gal-popup"
    ></receipt-image-popup>
    <serials-list-partial-popup
      :show="SerialsListPopup"
      @finish="onfinish"
      :popupService="popupService"
    ></serials-list-partial-popup>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import SerialsListPartialPopup from "./SerialsListPartialPopup.vue";
import ReceiptImagePopup from "../../shipping-management/Details_Package1/ReceiptImagePopup.vue";

import { mapGetters, mapActions } from "vuex";
export default {
  name:
    " warehouseManagement_CheckOutTransactions_CheckOutforDraftOrderDetails",
  components: {
    DataGrid,
    SerialsListPartialPopup,
    ReceiptImagePopup
  },
  data() {
    var id = this.$route.params.id;
    return {
      permission231: "GetStockDraftOrdersForPrint",
      permission232: "CreateOrder",
      permission233: "GetDischargePermissionByIdAndStoreId",
      permission235: "GetPackagesInfo",
      onShowReceiptImagePopup: false,
      PackagereceiptImageInfo: "",
      gridDataSource: {
        type: "app",
        service: "Inventory/api/InventoryTransactionsQuery/" + id + "/0"
      },
      gridSearchData: {},
      SerialsListPopup: false,
      popupService: "",
      disabled: false,
      headerLoaded: false
    };
  },
  computed: {
    ...mapGetters({
      headerInfo: "draftOrder/checkoutDetails"
    })
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchSingle: "draftOrder/fetchSingleCheckout",
      createOrder: "order/createOrder",
      showReceiptImage: "shipping/showReceiptImage"
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchSingle(id).then(() => {
        this.headerLoaded = true;
      });
    },
    backToCurrentGrid() {
      this.$router.push({
        path: "/CheckOutTransactions/Index",
        query: {
          referencePageInfo: {
            tabIndex: this.$route.query.tabIndex,
            numberRowsPerPage: this.$route.query.numberRowsPerPage
          }
        }
      });
    },
    isShowReceiptImage() {
      this.showReceiptImage(this.$route.params.id).then(r => {
        if (r) {
          this.onShowReceiptImagePopup = true;
          this.PackagereceiptImageInfo = r;
        } else {
          this.$swal({
            position: "center-center",
            type: "warning",
            text: "تاکنون رسیدی برای این مرسوله ثبت نشده است!",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    },
    viewSerials(inventoryTransactionId, shelveId, stockId) {
      this.popupService =
        "/Inventory/api/InventoryTransactionsQuery/serials/" +
        inventoryTransactionId +
        "/" +
        shelveId +
        "/" +
        stockId;
      this.SerialsListPopup = true;
    },
    onfinish() {
      this.SerialsListPopup = false;
      this.onShowReceiptImagePopup = false;
      this.$refs.grid.renderGrid();
    },
    createOrderInvoice() {
      this.$swal({
        title: "آیا از ثبت فاکتور اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر"
      }).then(result => {
        if (result.value) {
          this.disabled = true;
          this.createOrder(this.headerInfo.id).then(() => {
            setTimeout(() => {
              this.$router.push("/CheckOutTransactions/Index");
            }, 3000);
          });

          this.disabled = false;
        }
      });
    }
  }
};
</script>
<style>
#gal-popup .vs-popup--content {
  overflow-y: visible !important;
}
</style>
